import StorageUtils from "./services/storage";
import Version from "./utilities/version";

export const upgradeLocalStorage = () => {
    StorageUtils.updateLocalStorage("ui", Version.getVersion());
    StorageUtils.updateLocalStorage("state", Version.getVersion());
}

export interface ChangelogSection {
    title: string;
    details: string[];
}

export interface ChangelogData {
    version: string;
    date: string;
    changelog: {
        enhancements: ChangelogSection[];
        bugFixes: ChangelogSection[];
        newFeatures: ChangelogSection[];
        migration: ChangelogSection[];
    };
    fullChangelogUrl: string;
}

/**
 * Fetches the changelog JSON file matching the given version.
 * @param version - The current app version.
 * @returns A promise resolving to the parsed changelog JSON data.
 * @throws Error if the file is not found or cannot be loaded.
 */
export const fetchChangelog = async (): Promise<ChangelogData> => {
    try {
        const version = Version.getVersion();
        const data = await import(`../.changelog/${version}.json`);
        return data;
    } catch (error) {
        console.error(`Error fetching changelog: ${error}`);
        throw error;
    }
};
